module.exports = __webpack_public_path__ + "static/media/DVD.0aca6500.svg";